import { useState, useEffect } from "react";
import Box from '@mui/material/Box';
import Rating from '@mui/material/Rating';

const StarRating = (props) => {
  const { id, name, type, typeName, order, options, required, input: { onChange } } = props;

  const [rating, setRating] = useState(0);

  useEffect(() => {
    if (options?.length > 0) {
      for (let i = 0; i < options.length; i++) {
        if (options[i].default) {
          changeHandler(options[i]?.value);
        }
      }
    }
  }, []);

  const changeHandler = (newRating) => {
    if (!required && newRating === rating) {
      newRating = null;
    }
    setRating(newRating);

    if (!newRating) {
      return onChange(null);
    }
    return onChange(
      {
        id,
        typeName,
        order,
        result: newRating
      }
    );
  }

  return (
    <Rating
      name="simple-controlled"
      value={rating}
      size="large"
      onChange={(event, newValue) => {
        changeHandler(newValue);
      }}
    />
  );

  // return (
  //   <div className="star-rating">
  //     {[...Array(5)].map((star, index) => {
  //       index += 1;
  //       return (
  //         <button
  //           type="button"
  //           key={index}
  //           className={index <= (hover || rating) ? "on" : "off"}
  //           onClick={() => changeHandler(index)}
  //           onMouseEnter={() => setHover(index)}
  //           onMouseLeave={() => setHover(rating)}
  //         >
  //           <span className="star">&#9733;</span>
  //         </button>
  //       );
  //     })}
  //   </div>
  // );
};

export default StarRating;